import styles from './style.postcss';
import tabsStyles from './Tabs/style.postcss';

import React, { PureComponent } from 'react';
import SubNav from './SubNav';
import Tabs from './Tabs';
import is from 'is_js';
import { HorizontalScroll } from 'omni-common-ui';
import PropTypes from 'prop-types';
import TabNavBuilder from 'domain/TabNavBuilder';

const TABS_SCROLL_TO_ELEMENT = {  // passed to iScroll's scrollToElement
  selector: `.${tabsStyles.__active}`,
  duration: 300,
  easing: { style: 'ease-in-out' },
};

class TabNav extends PureComponent {
  constructor(props) {
    super(props);
    this._buildTabs(props);
  }

  componentWillUpdate(nextProps) {
    this._buildTabs(nextProps);
  }

  _getCurrentRouteSegment(routes) {
    return routes && routes[routes.length - 1];
  }

  _buildTabs(props) {
    const { routes, params } = props;
    if (is.not.array(routes) || ! routes.length) {
      this._tabs = null;
    }

    this._tabs = TabNavBuilder.buildNavItemsForRoutes(routes, params)
        .map((item) => TabNavBuilder.convertNavItemToTabItem(item, routes));
  }

  _shouldRender() {
    const { routes } = this.props;
    const currentRoute = this._getCurrentRouteSegment(routes);
    if (currentRoute &&
      currentRoute.tabs &&
      currentRoute.tabs.hidden === true) {
      return false;
    }

    return true;
  }

  _renderSecondLevelTabs() {
    const config = this.props.routes.find((route) => is.function(route.secondLevelTabs));
    if (! config) {
      return null;
    }
    const items = config.secondLevelTabs(this.props);

    return is.not.empty(items) && <SubNav items={items} />;
  }

  render() {
    if (! this._shouldRender()) {
      return null;
    }

    return <div className={styles.TabNav}>
      <div className={styles.TabNav_tabs_wrap}>
        <HorizontalScroll innerClassName={styles.TabNav_tabs_scroller}
            scrollToElement={TABS_SCROLL_TO_ELEMENT}>
          <Tabs className={styles.TabNav_tabs} items={this._tabs} />
        </HorizontalScroll>
      </div>
      {this._renderSecondLevelTabs()}
    </div>;
  }
}

TabNav.Tabs = Tabs;

TabNav.propTypes = {
  params: PropTypes.shape({}),
  routes: PropTypes.arrayOf(PropTypes.shape({})),
};

export default TabNav;



// WEBPACK FOOTER //
// ./components/TabNav/index.jsx